export default __webpack_public_path__ + "static/app-store-download-min-3e8affa847771349cfc39dd9dc169ed9.svg";